module.exports = __webpack_public_path__ + "static/media/activity-lesson-inside.88f42b09.png";